import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

const TESTIMONIALS = [
  {
    metric: '+32%',
    metricLabel: 'CA en 3 mois',
    quote:
      "Avant Velko, je fermais la caisse chaque soir sans savoir combien j'avais vendu. Maintenant je vois tout, temps réel, même quand le réseau coupe.",
    name: 'Aïcha Mballa',
    role: 'Boutique Sira',
    city: 'Dakar · SN',
    initials: 'AM',
    color: 'bg-lime-500',
  },
  {
    metric: '3 min',
    metricLabel: 'setup initial',
    quote:
      "J'ai mis Velko en place à Abidjan en 3 minutes. Mon vendeur a commencé à encaisser la même journée sans formation. Le support WhatsApp a suivi.",
    name: 'Kouassi Yao',
    role: 'TechShop Plateau',
    city: 'Abidjan · CI',
    initials: 'KY',
    color: 'bg-terracotta-500',
  },
  {
    metric: '0 F',
    metricLabel: 'perdu offline',
    quote:
      'Chez nous à Yaoundé, le réseau coupe souvent. Avant, chaque coupure = ventes perdues. Avec Velko, la caisse continue, et tout se synchronise après.',
    name: 'Samuel Nguema',
    role: 'Alimentation Mvan',
    city: 'Yaoundé · CM',
    initials: 'SN',
    color: 'bg-lime-400',
  },
] as const;

export default function TestimonialsWithMetricsV2() {
  return (
    <section className="bg-charcoal-800 py-24 text-white md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <SectionLabel tone="dark" className="justify-center">
            Ce qui change pour eux
          </SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(32px,4.2vw,54px)] font-bold leading-[1] tracking-[-0.035em]">
            Des résultats concrets, <span className="text-lime-400">pas des slogans</span>.
          </h2>
          <p className="mt-4 font-marketing-body text-lg text-charcoal-200">
            3 commerçants africains. 3 réalités. 3 chiffres.
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {TESTIMONIALS.map((t) => (
            <article
              key={t.name}
              className="flex flex-col border-2 border-charcoal-800 bg-white p-7 text-charcoal-800 shadow-neobrutal-lime-10"
            >
              <div className="font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-600">
                {t.metricLabel}
              </div>
              <div className="mt-2 font-marketing-display text-[64px] font-bold leading-[0.9] tracking-[-0.035em] text-lime-600">
                {t.metric}
              </div>

              <blockquote className="mt-6 border-l-[3px] border-lime-500 pl-4 font-marketing-body text-[16px] italic leading-relaxed text-charcoal-700">
                « {t.quote} »
              </blockquote>

              <div className="mt-6 flex items-center gap-3 border-t-2 border-dashed border-charcoal-200 pt-5">
                <span
                  className={`flex h-11 w-11 items-center justify-center border-2 border-charcoal-800 font-marketing-display text-sm font-bold text-charcoal-800 ${t.color}`}
                >
                  {t.initials}
                </span>
                <div>
                  <div className="font-marketing-display text-[15px] font-bold leading-tight text-charcoal-800">
                    {t.name}
                  </div>
                  <div className="font-marketing-mono text-[11px] uppercase tracking-[0.1em] text-charcoal-500">
                    {t.role} · {t.city}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
